import { useMemo, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import DataNotFound from "../ui/loader/data-not-found";
import { ChartMainCard } from "../LeadsDashboardComponents/ChartsHeader";
import { TeamAvailability } from "../LeadsDashboardComponents/StatCardIcons";
import InnerLoader from "../ui/loader/inner-loader";

export function LeadsByStageChart({ statusData =[], statusApiLoading, onBarClick }) {



  // Prepare categories and values
  const categories = useMemo(() => statusData?.map((item) => item?.lead_status), [statusData]);
  const totalValueData = useMemo(() => statusData?.map((item) => Number(item?.total_leads)), [statusData]);

  // Highcharts options
  const chartOptions = useMemo(() => ({
    chart: {
      type: "bar",
      inverted: true,
      backgroundColor: "transparent",
      height: "400px",
      animation: { duration: 800 },
    },
    title: { text: null },
    xAxis: {
      categories,
      labels: {
        style: { color: "#6b7280", fontSize: "13px", cursor: "pointer" },
      },
      gridLineWidth: 0,
    },
    yAxis: {
      title: { text: null },
      labels: { style: { color: "#6b7280", fontSize: "13px" } },
      gridLineColor: "#06B6D4",
      gridLineDashStyle: "Dash",
    },
    plotOptions: {
      series: {
        borderRadius: 6,
        cursor: "pointer",
        states: {
          hover: {
            enabled: true,
            brightness: 0.1,
            halo: {
              size: 6,
              attributes: { fill: "#06B6D4", opacity: 0.2 }
            }
          },
        },
        point: {
          events: {
            click: function () {
              if (onBarClick) onBarClick(this.category, this.y);
            },
          },
        },
        dataLabels: {
          enabled: true,
          format: "{point.y}",
          style: { color: "#374151", fontWeight: "500" },
        },
      },
      bar: {
        pointWidth: 30,
        pointPadding: 0.1,
        groupPadding: 0.2,
      },
    },
    series: [
      {
        name: "Total Leads",
        data: totalValueData.map((val) => ({
          y: val,
          color: {
            linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
            stops: [
              [0, "#06B6D4"],
              // [1, "#CAA3FC"],
            ],
          },
        })),
      },
    ],
    tooltip: {
      formatter: function () {
        return `<b>${this.key}</b>: ${this.y.toLocaleString()}`;
      },
      backgroundColor: "#f9fafb",
      borderColor: "#06B6D4",
      borderRadius: 6,
      style: { color: "#111827", fontSize: "13px" },
    },
    legend: { enabled: false },
    credits: { enabled: false },
  }), [categories, totalValueData, onBarClick]);

  return (
    <ChartMainCard
      Icon={<TeamAvailability />}
      iconColor="bg-[#DBEAFE] text-[#06B6D4]"
      heading="Leads Status Breakdown"
      subHeading="Status-wise analysis of current lead positions"
    >
      {!statusApiLoading ? (
        <div className="p-6 h-full">
          {statusData?.length > 0 ? (
            <HighchartsReact highcharts={Highcharts} options={chartOptions} />
          ) : (
            <DataNotFound title="Status Data" />
          )}
        </div>
      ) : (
        <InnerLoader />
      )}
    </ChartMainCard>
  );
}

